import { Component } from '@angular/core';

@Component({
  selector: 'gplus-icon-organization-settings',
  imports: [],
  templateUrl: './icon-organization-settings.component.html',
  styleUrl: './icon-organization-settings.component.scss',
})
export class IconOrganizationSettingsComponent {

}
